import { useSessionConfiguration } from '#src/app/shared/hooks/sessionConfiguration';
import { isLoaded } from '#src/app/shared/utils/async';

import { useSessionAsync } from './get';

/**
 * Can be used to determine if the current session is a guest session, including with server caching.
 */
export function useIsGuest(): boolean {
	const { initialGuestState } = useSessionConfiguration();
	const sessionState = useSessionAsync();

	return isLoaded(sessionState) ? sessionState.value.loginState === 'GUEST' : initialGuestState;
}
